import type { ReferralAPI } from '../reducer.ts'
import { ReferralFormSectionName, ReferralOppSections } from './reducer.ts'

export type SanitizedReferralPartition = {
  populatedFields: Partial<ReferralAPI>
  fieldsClearedToNull: Partial<ReferralAPI>
}

export const partitionSanitizedReferralForMerge = (
  sanitizedPayload: Partial<ReferralAPI>
): SanitizedReferralPartition => {
  const populatedFields: Record<string, unknown> = {}
  const fieldsClearedToNull: Record<string, null> = {}

  for (const [key, value] of Object.entries(sanitizedPayload)) {
    if (value !== undefined && value !== '') {
      populatedFields[key] = value
    }
    if (value === '') {
      fieldsClearedToNull[key] = null
    }
  }

  return {
    populatedFields: populatedFields as Partial<ReferralAPI>,
    fieldsClearedToNull: fieldsClearedToNull as Partial<ReferralAPI>,
  }
}

/** Accept/reject sends only projectDetails with acceptanceStatus; submit updates sends the full form. */
export const isAcceptRejectOnlyPayload = (
  referral: Partial<ReferralOppSections>
): boolean => {
  const sections = Object.keys(referral).filter(
    key => referral[key as keyof ReferralOppSections] != null
  )
  if (sections.length !== 1) {
    return false
  }
  if (sections[0] !== ReferralFormSectionName.PROJECT_DETAILS) {
    return false
  }
  const status =
    referral[ReferralFormSectionName.PROJECT_DETAILS]?.acceptanceStatus
  return status === 'Accepted' || status === 'Rejected'
}
